import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/sector_skills.json";

export const useSectorSkills = () => {
  // const rawData = useSourceFlowCollection(data);
  //
  // const uniqueData = Array.from(new Set(rawData.map((item) => item.title))).map((role) =>
  //   rawData.find((item) => item.title === role),
  // );
  //
  // return uniqueData;
  return useSourceFlowCollection(data);
};

export default useSectorSkills;
